import React from 'react';

const NavLinks = () => {
  return(
    <ul className="navlinks-list">
      <li>
        <a href="#home" alt="Home">
          Home
        </a>
      </li>
      <li>
        <a href="#about" alt="About Me">
          About Me
        </a>
      </li>
      <li>
        <a href="#portfolio" alt="Portfolio">
          Portfolio
        </a>
      </li>
      <li>
        <a href="#contacts" alt="Contacts">
          Contacts
        </a>
      </li>
    </ul>
    )
}

export default NavLinks;